export default __webpack_public_path__ + "static/media/UiStatsW.8c4c48c6.svg";